import { FC, useState, useRef } from "react";
import {
  Create,
  CreateProps,
  FormGroupContextProvider,
  FormWithRedirect,
  maxValue,
  minValue,
  NumberInput,
  required,
} from "react-admin";
// @ts-ignore
import { ColorInput } from "react-admin-color-input";
import BackgroundColor from "../../components/BackgroundColor";

import CustomCard from "../../components/CustomCard";
import CustomToolbar from "../../components/CustomToolbar";
import FormWrapper from "../../components/FormWrapper";
import ImageUploadInput from "../../components/ImageUploadInput";
import Spacing from "../../components/Spacing";
import useDisabledOnLoading from "../../hooks/useDisabledOnLoading";
import { FormGroupNames } from "../../types/reactAdmin.types";
import { AppResource } from "../../types/resource.types";
import { int, validateFileSize } from "../../utils/validators";
import { useSportTypesLocalizations } from "./utils";

const CustomForm: FC<any> = (props) => {
  const { bgColorRef } = props;
  const { disabledStyles } = useDisabledOnLoading();
  const localizedInputs = useSportTypesLocalizations(props);
  const [error, setError] = useState("Background is required");

  return (
    <FormWrapper>
      <FormGroupContextProvider name={FormGroupNames.sportTypesCreate}>
        <FormWithRedirect
          {...props}
          redirect={`/${AppResource.sportTypes}`}
          render={(formProps) => (
            <form style={disabledStyles}>
              <CustomCard title="Details">
                <Spacing>{localizedInputs}</Spacing>

                <NumberInput
                  variant="outlined"
                  source="sortIndex"
                  style={{ width: "100%" }}
                  validate={[required(), int(), minValue(0), maxValue(20)]}
                />
              </CustomCard>

              <CustomCard title="Icon (png/should be transparent)">
                <ImageUploadInput source="icon" accept="image/png" validate={[required(), validateFileSize("icon")]} />
              </CustomCard>

              <BackgroundColor
                onChangeBGColor={(value) => (bgColorRef.current = value)}
                onError={(error: string) => setError(error)}
              />

              <CustomToolbar
                {...formProps}
                formName={FormGroupNames.sportTypesCreate}
                customErrors={{
                  backgroundColor: error,
                }}
              />
            </form>
          )}
        />
      </FormGroupContextProvider>
    </FormWrapper>
  );
};

const SportTypesCreate: FC<CreateProps> = (props) => {
  const bgColorRef = useRef();
  return (
    <Create
      {...props}
      transform={(values) => {
        values.deleted = false;
        values.backgroundColor = bgColorRef.current;
        return values;
      }}
      component="section"
    >
      <CustomForm bgColorRef={bgColorRef} />
    </Create>
  );
};

export default SportTypesCreate;
